import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { FormattedMessage } from '../../util/reactIntl';
import { LISTING_STATE_DRAFT } from '../../util/types';
import { ListingLink } from '..';
import { EditListingRelationshipsForm } from '../../forms';
import { ensureOwnListing } from '../../util/data';
import { types as sdkTypes } from '../../util/sdkLoader';
import config from '../../config';

import css from './EditListingRelationshipsPanel.module.css';
import { postAdminListingPublic } from '../../util/api';
import BackToAdmin from '../BackToAdminButton/BackToAdminButton';

const { Money } = sdkTypes;

const EditListingRelationshipsPanel = props => {
  const {
    className,
    rootClassName,
    listing,
    disabled,
    ready,
    onSubmit,
    onChange,
    submitButtonText,
    panelUpdated,
    updateInProgress,
    errors,
  } = props;

  const classes = classNames(rootClassName || css.root, className);
  const currentListing = ensureOwnListing(listing);
  const { price } = currentListing.attributes;
  const { owner, propertyManager, teacherFirstName, teacherLastName, teacherSchool, teacherYearsAtOUSD } = currentListing.attributes.publicData;

  const isPublished = currentListing.id && currentListing.attributes.state !== LISTING_STATE_DRAFT;
  const panelTitle = isPublished ? (
    <FormattedMessage
      id="EditListingRelationshipsPanel.title"
      values={{ listingTitle: <ListingLink listing={listing} /> }}
    />
  ) : (
    <FormattedMessage id="EditListingRelationshipsPanel.createListingTitle" />
  );

  const priceCurrencyValid = price instanceof Money ? price.currency === config.currency : true;
  const form = priceCurrencyValid ? (
    <EditListingRelationshipsForm
      className={css.form}
      initialValues={{ owner, propertyManager, teacherFirstName, teacherLastName, teacherSchool, teacherYearsAtOUSD }}
      onSubmit={values => {
        const { owner, propertyManager, teacherFirstName, teacherLastName, teacherSchool, teacherYearsAtOUSD } = values;

        const publicData = {owner, propertyManager, teacherFirstName, teacherLastName, teacherSchool, teacherYearsAtOUSD,};
        const payload = {
          id: listing.id.uuid,
          publicData
        };
        postAdminListingPublic(payload)
        onSubmit({price});
      }}
      onChange={onChange}
      saveActionMsg={submitButtonText}
      disabled={disabled}
      ready={ready}
      updated={panelUpdated}
      updateInProgress={updateInProgress}
      fetchErrors={errors}
    />
  ) : (
    <div className={css.priceCurrencyInvalid}>
      <FormattedMessage id="EditListingRelationshipsPanel.listingPriceCurrencyInvalid" />
    </div>
  );

  return (
    <div className={classes}>
      <BackToAdmin />
      <h1 className={css.title}>{panelTitle}</h1>
      {form}
    </div>
  );
};

const { func, object, string, bool } = PropTypes;

EditListingRelationshipsPanel.defaultProps = {
  className: null,
  rootClassName: null,
  listing: null,
};

EditListingRelationshipsPanel.propTypes = {
  className: string,
  rootClassName: string,

  // We cannot use propTypes.listing since the listing might be a draft.
  listing: object,

  disabled: bool.isRequired,
  ready: bool.isRequired,
  onSubmit: func.isRequired,
  onChange: func.isRequired,
  submitButtonText: string.isRequired,
  panelUpdated: bool.isRequired,
  updateInProgress: bool.isRequired,
  errors: object.isRequired,
};

export default EditListingRelationshipsPanel;
